import type { Experience } from "../experience";

// First surface of an experience: where a role switch lands.
export const homeTab = (x: Experience): string =>
  x === "admin" ? "inbox" : x === "coach" ? "coachDashboard" : "plan";

// What the experience row does when a role is picked (#208). Pure: the shell
// injects its leave guard and its setters, so the decision is testable without
// React or the DOM. Always through the leave guard (a dirty editor confirms
// first). Picking the role already shown goes back to its first surface (the
// chip is the way out of Settings or a Me section, as on the phone); any other
// role is set, and the shell's experience effect points at that role's tab.
export function selectExperience(deps: {
  next: Experience;
  current: Experience;
  guardedLeave: (go: () => void) => void;
  goTab: (key: string) => void;
  setExperience: (x: Experience) => void;
}): void {
  const { next, current, guardedLeave, goTab, setExperience } = deps;
  guardedLeave(() => {
    if (next === current) goTab(homeTab(next));
    else setExperience(next);
  });
}
